/* eslint-disable @typescript-eslint/ban-types */
export interface IAPIUrls {
  managers: {
    getById: Function;
    getByAgreement: Function;
  };
  media: string;
  contacts: Function;
  applyNow: string;
  schools: string;
  employees: {
    search: string;
    verify: string;
    searchByFullSsn: string;
    validateSN: string;
    validatePhone: Function;
    validateAddress: string;
    isActiveEmployee: Function;
    team: Function;
    convertContact: string;
    recruitingLocation: string;
    photoUpdate: Function;
  };
  agreement: {
    terms: Function;
    pastEmployeeFormData: string;
    options: Function;
    send: Function;
    resign: Function;
    check: Function;
    currentUserAgreement: string;
    taskInfo: string;
  };
  supportContacts: string;
  tasks: {
    recruit: string;
    complete: Function;
  };
  directDeposit: string;
  profilePhoto: string;
  driverLicense: string;
  governmentId: string;
  profile: {
    options: Function;
    contactInfo: Function;
    profileInfo: string;
    piiInfoAvailability: string;
    piiInfo: string;
    emergencyContacts: Function;
    namesInfo: Function;
  };
  device: {
    requests: Function;
    status: Function;
    options: string;
  };
  apparels: {
    options: string;
    info: string;
  };
  taxDocuments: {
    options: string;
    task: string;
    w4Options: string;
    w4Info: string;
    ssn: string;
  };
  workdayAccount: {
    options: string;
    task: string;
    rehire: string;
  };
  okta: {
    refreshToken: string;
    accessToken: string;
  };
  backgroundCheck: {
    consentText: string;
    confirm: string;
    status: string;
    mvrStatus: string;
    drugStatus: string;
  };
  legalTrainings: {
    lessonGroups: string;
    lesson: Function;
    quiz: Function;
    section: Function;
    question: Function;
  };
  i9: {
    info: string;
    reinitiate: string;
    verificationMethod: string;
    updateStatus: string;
  };
  accounts: string;
  options: {
    state: Function
  };
  passwordPolicy: string;
  about: string;
}

export function getApiConstants(baseUrl): IAPIUrls {
  return {
    managers: {
      getById: (id) => baseUrl + `/api/managers/${id}`,
      getByAgreement: (publicKey) => baseUrl + `/api/managers/agreement/${publicKey}`,
    },
    media: baseUrl + '/api/media/sale-introduction-video',
    contacts: (id) => baseUrl + `/api/recruiters/${id}/contacts`,
    applyNow: baseUrl + `/api/apply-now`,
    schools: baseUrl + '/api/schools',
    employees: {
      search: baseUrl + '/api/employees/search',
      verify: baseUrl + '/api/employees/verify',
      searchByFullSsn: baseUrl + '/api/employees/search-by-full-ssn',
      validateSN: baseUrl + '/api/employees/validate-sn',
      validatePhone: (phone) => baseUrl + `/api/rot/is-phone-number-valid?phoneNumber=${phone}`,
      validateAddress: baseUrl + '/api/address',
      isActiveEmployee: (employeeId) => baseUrl + `/api/employees/${employeeId}/is-account-active`,
      team: (pageNumber, size) => baseUrl + `/api/rot/team-members?pageNumber=${pageNumber}&pageSize=${size}`,
      convertContact:  baseUrl + `/api/agreements/change-agreement-signer`,
      recruitingLocation:  baseUrl + `/api/recruits/current/recruiting-location`,
      photoUpdate: (employeeId) => baseUrl + `/api/employees/${employeeId}/photo`,
    },
    agreement: {
      terms: (publicKey) => baseUrl + `/api/agreements/${publicKey}/terms`,
      pastEmployeeFormData: baseUrl + `/api/agreements/past-employee-form-data`,
      options: (publicKey) =>
        baseUrl + `/api/agreements/${publicKey}/formOptions`,
      send: (publicKey) =>
        baseUrl + `/api/agreements/${publicKey}`,
      resign: (publicKey) =>
        baseUrl + `/api/agreements/${publicKey}/resign`,
      check: (publicKey) =>
        baseUrl + `/api/agreements/${publicKey}`,
      currentUserAgreement: baseUrl + '/api/agreements/current-employee-agreement',
      taskInfo: baseUrl + '/api/onboarding-tasks/agreement'
    },
    supportContacts: baseUrl + '/api/info/supportContacts',
    tasks: {
      recruit: baseUrl + '/api/rot',
      complete: (taskId) => baseUrl + `/api/onboarding-tasks/${taskId}/complete`
    },
    directDeposit: baseUrl + `/api/onboarding-tasks/direct-deposit`,
    profilePhoto: baseUrl + '/api/rot/profilephoto',
    driverLicense: baseUrl + '/api/onboarding-tasks/driver-license',
    governmentId: baseUrl + '/api/onboarding-tasks/government-id',
    profile: {
      options: (id) =>
        baseUrl + `/api/recruits/${id}/formOptions`,
      contactInfo: (id) =>
        baseUrl + `/api/recruits/${id}/contact-info`,
      profileInfo: baseUrl + `/api/rot/profile`,
      piiInfoAvailability: baseUrl + `/api/recruits/current/pii-info-availability`,
      piiInfo: baseUrl + `/api/recruits/current/pii-info`,
      emergencyContacts: (id) =>
        baseUrl + `/api/recruits/${id}/emergency-contact`,
      namesInfo: (agreementPublicKey) =>
        baseUrl + `/api/recruits/${agreementPublicKey}/name-info`
    },
    device: {
      requests: (requestId = '') =>
        baseUrl + `/api/device-requests/${requestId}`,
      status: (recruitId) =>
        baseUrl + `/api/recruits/${recruitId}/deviceRequest`,
      options: baseUrl + '/api/options/state'
    },
    apparels: {
      options: baseUrl + `/api/apparels/options`,
      info: baseUrl + `/api/apparels`
    },
    taxDocuments: {
      options: baseUrl + `/api/onboarding-tasks/w9/business-types`,
      task: baseUrl + `/api/onboarding-tasks/w9`,
      w4Options: baseUrl + `/api/onboarding-tasks/w4/marital-statuses`,
      w4Info: baseUrl + `/api/onboarding-tasks/w4`,
      ssn: baseUrl + `/api/recruits/current/ssn`
    },
    workdayAccount: {
      options: baseUrl + `/api/onboarding-tasks/workday-account/form-options`,
      task: baseUrl + `/api/onboarding-tasks/workday-account`,
      rehire: baseUrl + `/api/onboarding-tasks/workday-account-rehire`
    },
    okta: {
      refreshToken: baseUrl + '/api/token/refresh-token',
      accessToken: baseUrl + '/api/token/access-token'
    },
    backgroundCheck: {
      consentText: baseUrl + `/api/background-check/consent-text`,
      confirm: baseUrl + `/api/background-check/consents`,
      status: baseUrl + `/api/onboarding-tasks/background-check`,
      mvrStatus: baseUrl + `/api/onboarding-tasks/mvr-status`,
      drugStatus: baseUrl + `/api/onboarding-tasks/drug-check-status`
    },
    legalTrainings: {
      lessonGroups: baseUrl + `/api/onboarding-tasks/legal-trainings`,
      lesson: (lessonId) => baseUrl + `/api/trainings/all/lessons/${lessonId}`,
      quiz: (lessonId) =>
        baseUrl + `/api/trainings/all/lessons/${lessonId}/quiz`,
      section: (sectionId) =>
        baseUrl + `/api/trainings/all/sections/${sectionId}`,
      question: (questionId) =>
        baseUrl + `/api/trainings/all/questions/${questionId}`,
    },
    i9: {
      info: baseUrl + `/api/onboarding-tasks/i9`,
      reinitiate: baseUrl + `/api/onboarding-tasks/i9`,
      verificationMethod: baseUrl + `/api/i9/verification-method`,
      updateStatus: baseUrl + `/api/i9/rot-update-status`,
    },
    accounts: baseUrl + `/api/accounts`,
    options: {
      state: (country) => baseUrl + '/api/options/state?country=' + country
    },
    passwordPolicy: baseUrl + '/api/password-policy',
    about: baseUrl + '/api/about'
  };
}

export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'
];
